// extracted by mini-css-extract-plugin
export default {"wrapper":"FlavourBanVideo_wrapper__Vt+gU","content":"FlavourBanVideo_content__ow9wR","completed":"FlavourBanVideo_completed__LCMhO"};